export const JobType = [
    { id: 0, name: "-- SELECT --" },
    { id: 1, name: "Onsite" },
    { id: 2, name: "Hybrid" },
    { id: 3, name: "Remote" },
]
export const Term = [
    { id: 0, name: "-- SELECT --" },
    { id: 1, name: "Contract" },
    { id: 2, name: "Contract-to-Hire" },
    { id: 3, name: "Permanent" },
]
export const Priority = [
    { id: 0, name: "-- SELECT --" },
    { id: 1, name: "Low" },
    { id: 2, name: "High" },
    { id: 3, name: "Very High" },
]
export const InterviewProcess = [
    { id: 0, name: "-- SELECT --" },
    { id: 1, name: "Telephonic" },
    { id: 2, name: "F2F" },
    { id: 3, name: "Skype" },
    { id: 4, name: "Tele + F2F" },
    { id: 5, name: "Skype + F2F" },
    { id: 6, name: "Tel/Skype + F2F" },
    { id: 7, name: "Telephonic / F2F" },
    { id: 8, name: "Tel/Webex" },
    { id: 9, name: "Tel/Zoom" },
    { id: 10, name: "Tel/Spark Hire" },
]
export const client_Type = [
    { id: 1, clientTypeName: 'Direct Client' },
    { id: 2, clientTypeName: 'Implementing Partner' }
]
export const special_Constraints = [
    { name: 'PV W2' },
    { name: 'OUR W2' },
    { name: 'Active Security Clearance' },
    { name: 'No Constraints' },
]
export const EClient_Communication = [
    { name: "-- SELECT --" },
    { name: "Phone" },
    { name: "Email" },
    { name: "Chat" },
]
export const POStatus = [
    { name: "To Join" },
    { name: "Fizzled" },
    { name: "Joined" },
    { name: "Ended" },
]
export const PODocType = [
    { name: "Consultant" },
    { name: "Vendor" },
    { name: "Client" },
]
export const ECIType = [
    { name: "Telephonic" },
    { name: "In Person" },
    { name: "Skype" },
    { name: "Tele + F2F" },
    { name: "Skype + F2F" },
    { name: "Tel/Skype + F2F" },
    { name: "Telephonic / F2F" },
]
export const Positions = [
    { id: 1, name: "1" },
    { id: 2, name: "2" },
    { id: 3, name: "3" },
    { id: 4, name: "4" },
    { id: 5, name: "5" },
    { id: 6, name: "6" },
    { id: 7, name: "7" },
    { id: 8, name: "8" },
    { id: 9, name: "9" },
    { id: 10, name: "10" },
    { id: 11, name: "11" },
    { id: 12, name: "12" },
    { id: 13, name: "13" },
    { id: 14, name: "14" },
    { id: 15, name: "15" },
    { id: 16, name: "16" },
    { id: 17, name: "17" },
    { id: 18, name: "18" },
    { id: 19, name: "19" },
    { id: 20, name: "20" }
]
export const Experience = [
    { name: 1 },
    { name: 2 },
    { name: 3 },
    { name: 4 },
    { name: 5 },
    { name: 6 },
    { name: 7 },
    { name: 8 },
    { name: 9 },
    { name: 10 },
    { name: 11 },
    { name: 12 },
    { name: 13 },
    { name: 14 },
    { name: 15 },
    { name: 16 },
    { name: 17 },
    { name: 18 },
    { name: 19 },
    { name: 20 }
]
export const NoticePeriod = [
    { value: "0", name: "Immediate" },
    { value: "7", name: "One Week" },
    { value: "15", name: "Two Week" },
    { value: "30", name: "One Month" },
    { value: "60", name: "Two Month" },
    { value: "90", name: "Three Month" }
]
export const TaxTerm = [
    { name: "C2C with Benefits" },
    { name: "C2C All Inclusive" },
    { name: "1099 All Inclusive" },
    { name: "1099 with Benefits" },
    { name: "W2 All Inclusive" },
    { name: "W2 with Benefits" },
    { name: "Permanent" }
]

export const MatchingPer = [
    { name: 50 },
    { name: 60 },
    { name: 70 },
    { name: 80 },
    { name: 90 },
    { name: 100 }
]
export const CblType = [
    { name: "Contract" },
    { name: "Permanent" },
    { name: "C2C" }
]
export const ServedStatus = [
    { name: "-- SELECT --" },
    { name: "Served" },
    { name: "Unserved" },
    { name: "UnAllocated" },
    { name: "Rejected" }
]
export const Status = [
    { name: "-- SELECT --", value: null },
    { name: "Hold", value: true },
    { name: "Unhold", value: false }
]
export const TicketStatus = [
    { name: "Open" },
    { name: "InProgress" },
    { name: "Hold" },
    { name: "Answered" },
    { name: "Closed" }
]
